import { render, staticRenderFns } from "./ManageAwaitingAuditValidationView.vue?vue&type=template&id=5bdaede1"
import script from "./ManageAwaitingAuditValidationView.vue?vue&type=script&lang=ts"
export * from "./ManageAwaitingAuditValidationView.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports